/**
 * Name helpers for rendering staff records.
 *
 * The backend stores first_name + last_name separately (per Phase 2A
 * schema). For admin UI we always show the full "First Last" form.
 * The public verify endpoint does the display_name_mode logic on
 * the server, so we don't duplicate it here.
 */

export function fullName(staff) {
  if (!staff) return '';
  const first = (staff.first_name || '').trim();
  const last = (staff.last_name || '').trim();
  return [first, last].filter(Boolean).join(' ');
}

/**
 * "DM" for Dani Morgan, "J" for just Jez, "" if nothing.
 * Used by the avatar placeholder when no photo is set.
 */
export function initials(staff) {
  if (!staff) return '';
  const first = (staff.first_name || '').trim().charAt(0).toUpperCase();
  const last = (staff.last_name || '').trim().charAt(0).toUpperCase();
  return `${first}${last}`;
}

/**
 * "15 March 2024" — display-only, non-editable.
 * Kept here so it stays consistent everywhere.
 */
export function formatDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric',
  });
}
